import { render, staticRenderFns } from "./stocktake.vue?vue&type=template&id=6e5758bf&scoped=true&"
import script from "./stocktake.vue?vue&type=script&lang=js&"
export * from "./stocktake.vue?vue&type=script&lang=js&"
import style0 from "./stocktake.vue?vue&type=style&index=0&id=6e5758bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5758bf",
  null
  
)

export default component.exports